import { AxiosResponse } from 'axios';
import {
  AcceptUserInvitationRequest,
  AcceptUserInvitationResponse,
  CreateAuthChallengeUserRequest,
  CreateAuthChallengeUserResponse,
  CreateUserInvitationResponse,
  SetPropertiesOnUserRequest,
  SetUsersOnPropertyRequest,
  UserInvitationRequest,
  VerifyAuthChallengeUserRequest,
  VerifyAuthChallengeUserResponse,
} from 'vendor-marketplace-shared-library';

import http from './http-common';

class UserService {
  createAuthChallenge(
    contactMethodVerificationType: string,
    contactMethodType: string,
    contactMethodValue: string,
  ): Promise<AxiosResponse<CreateAuthChallengeUserResponse>> {
    return http.post(`/user/auth-challenge/create/${contactMethodVerificationType}`, {
      contactMethodType,
      contactMethodValue,
    } as CreateAuthChallengeUserRequest);
  }
  verifyAuthChallenge(
    contactMethodVerificationType: string,
    contactMethodVerificationId: number,
    contactMethodVerificationCode: string,
    firstName?: string,
    lastName?: string,
  ): Promise<AxiosResponse<VerifyAuthChallengeUserResponse>> {
    return http.post(`/user/auth-challenge/verify/${contactMethodVerificationType}`, {
      contactMethodVerificationId,
      contactMethodVerificationCode,
      firstName,
      lastName,
    } as VerifyAuthChallengeUserRequest);
  }

  activateUser(): Promise<AxiosResponse<void>> {
    return http.post('/user/activate');
  }

  cancelUserInvitation(userInvitationId: number): Promise<AxiosResponse<void>> {
    return http.post('/user/invitation/cancel', {
      userInvitationId,
    } as UserInvitationRequest);
  }

  deleteUserInvitation(userInvitationId: number): Promise<AxiosResponse<void>> {
    return http.post('/user/invitation/delete', {
      userInvitationId,
    } as UserInvitationRequest);
  }

  declineUserInvitation(userInvitationId: number): Promise<AxiosResponse<void>> {
    return http.post('/user/invitation/decline', {
      userInvitationId,
    } as UserInvitationRequest);
  }

  resendUserInvitation(
    userInvitationId: number,
  ): Promise<AxiosResponse<CreateUserInvitationResponse>> {
    return http.post('/user/invitation/resend', {
      userInvitationId,
    } as UserInvitationRequest);
  }

  acceptUserInvitation(
    userInvitationId: number,
  ): Promise<AxiosResponse<AcceptUserInvitationResponse>> {
    return http.post('/user/invitation/accept', {
      userInvitationId,
    } as AcceptUserInvitationRequest);
  }

  setPropertiesOnUsers(userId: number, propertyIds: number[]): Promise<AxiosResponse<void>> {
    return http.post('/user/properties/set', {
      userId,
      propertyIds,
    } as SetPropertiesOnUserRequest);
  }

  setUsersOnProperty(propertyId: number, userIds: number[]): Promise<AxiosResponse<void>> {
    return http.post('/property/users/set', {
      propertyId,
      userIds,
    } as SetUsersOnPropertyRequest);
  }
}

const userService = new UserService();

export default userService;
